module.exports = __webpack_public_path__ + "img/9788982738470.50d44ece.jpg";